export const apiRoutes = {
  HOME: '/',
  USER: '/user',
  DASHBOARD: '/dashboard',
  INTERESTS: '/interests',
  FEED: '/feed',
  POSTS: '/posts',
  DRAFTS: '/drafts',
  DIRECT_MESSAGES: '/direct-messages',
  REPLIES: '/replies',
  STORIES: '/stories',
  LIKES: '/likes',
  BOOKMARKED: '/bookmarked',
  FOLLOWING: '/following',
  SHARED: '/shared',
  SETTINGS: '/settings',
  CIRCLES: '/circles',
  VERIFY_IDENTITY: '/verify-identity',
  SIGNUP: '/sign-up',
  NOT_FOUND: '/not-found',
  LOGIN: '/log-in',
  LOGOUT: '/logout',
  REQUEST_RESET_PASSWORD: '/password-reset',
  RESET_PASSWORD: '/password-reset',
  GQL_URL: 'http://localhost:3000/api/graphql',
  POST_IMAGES: `/${import.meta.env.VITE_STAGE || 'dev'}/presigned-url`,
};

// Also provided as default export
export default apiRoutes;
